import { render, staticRenderFns } from "./RelatorioRecebimento.vue?vue&type=template&id=03ae7b90&scoped=true"
import script from "./RelatorioRecebimento.vue?vue&type=script&lang=ts"
export * from "./RelatorioRecebimento.vue?vue&type=script&lang=ts"
import style0 from "./RelatorioRecebimento.vue?vue&type=style&index=0&id=03ae7b90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03ae7b90",
  null
  
)

export default component.exports